
export const skillList = [
    {
        skillName: 'Python',
        skillUrl: process.env.PUBLIC_URL+'/images/python.png',
    },
    {
        skillName: 'Java',
        skillUrl: process.env.PUBLIC_URL+'/images/java.png',
    },
    {
        skillName: 'C++',
        skillUrl: process.env.PUBLIC_URL+'/images/c++.png',
    },
    {
        skillName: 'MySQL',
        skillUrl: process.env.PUBLIC_URL+'/images/mysql.png',
    },
    {
        skillName: 'PostgreSQL',
        skillUrl: process.env.PUBLIC_URL+'/images/postgre.png',
    },
    {
        skillName: 'MongoDB',
        skillUrl: process.env.PUBLIC_URL+'/images/mongo.png',
    },
    {
        skillName: 'HTML',
        skillUrl: process.env.PUBLIC_URL+'/images/html.png',
    },
    {
        skillName: 'CSS',
        skillUrl: process.env.PUBLIC_URL+'/images/css.png',
    },
    {
        skillName: 'Bootstarp',
        skillUrl: process.env.PUBLIC_URL+'/images/bootstarp.png',
    },
    {
        skillName: 'JavaScript',
        skillUrl: process.env.PUBLIC_URL+'/images/js.png',
    },
    {
        skillName: 'JQuery',
        skillUrl: process.env.PUBLIC_URL+'/images/jquery.png',
    },
    {
        skillName: 'TypeScript',
        skillUrl: process.env.PUBLIC_URL+'/images/ts.png',
    },
    {
        skillName: 'Angular',
        skillUrl: process.env.PUBLIC_URL+'/images/angular.png',
    },
    {
        skillName: 'React',
        skillUrl: process.env.PUBLIC_URL+'/images/react.png',
    },
    {
        skillName: 'NodeJS',
        skillUrl: process.env.PUBLIC_URL+'/images/node.png',
    },
    {
        skillName: 'Spring Boot',
        skillUrl: process.env.PUBLIC_URL+'/images/springboot.png',
    },
    {
        skillName: 'Flask',
        skillUrl: process.env.PUBLIC_URL+'/images/flask.png',
    },
    {
        skillName: 'Django',
        skillUrl: process.env.PUBLIC_URL+'/images/django.png',
    },
    {
        skillName: 'GCP',
        skillUrl: process.env.PUBLIC_URL+'/images/gcp.png',
    },
    {
        skillName: 'AWS',
        skillUrl: process.env.PUBLIC_URL+'/images/aws.png',
    }
];
